import React from 'react'
import { Collapse, List, ListItemText } from '@mui/material'
import { NenhumaPlataforma } from '../NenhumaPlataforma'
import { ItemMenu } from '../ItemMenu'
import { BotaoItem } from '../ItemMenu/ItemMenu.styles'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { useMenuLateral } from '../context/MenuLateralProvider/MenuLateralProvider'
import { useTranslation } from 'react-i18next'
import { Menu } from 'components/Header/types'

export type ListaItensMenuProps = {
  itens: Menu[]
  nome: string
  icone?: string
  isPersonalizado?: boolean
}

export function ListaItensMenu({
  itens,
  nome,
  icone,
  isPersonalizado
}: ListaItensMenuProps) {
  const { itemSelecionado, persistirMenus, setPersistirMenus } =
    useMenuLateral()
  const { t } = useTranslation('translation', {
    keyPrefix: 'componentes.menu_lateral'
  })
  const aberto = persistirMenus.includes(nome)

  const handleClick = () => {
    if (aberto) {
      const menus = persistirMenus.filter(menu => menu !== nome)
      setPersistirMenus(menus)
    } else {
      const menus = [...persistirMenus, nome]
      setPersistirMenus(menus)
    }
  }

  const subItemSelecionado = () => {
    const selecionado = itens.some(item => {
      return aberto ? false : itemSelecionado === item.rota
    })
    return selecionado
  }

  return (
    <>
      <BotaoItem selected={subItemSelecionado()} onClick={handleClick}>
        <ListItemText primary={nome} />
        {aberto ? <ExpandLess /> : <ExpandMore />}
      </BotaoItem>
      <Collapse in={aberto} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {!itens.length ? (
            <NenhumaPlataforma />
          ) : (
            <>
              {itens.map(item => (
                <ItemMenu
                  paddingleft={4}
                  key={item.id}
                  nome={item.label ? item.label : t('sem_traducao')}
                  rota={item.rota ? item.rota : ''}
                  icone={icone}
                  isPlatform={item.isPlatform}
                  isPersonalizado={isPersonalizado}
                />
              ))}
            </>
          )}
        </List>
      </Collapse>
    </>
  )
}
